import { render, staticRenderFns } from "./RawModel2.vue?vue&type=template&id=8a1c11a2"
import script from "./RawModel2.vue?vue&type=script&lang=js"
export * from "./RawModel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports